import React from 'react';

// The thin orange / blue / yellow diagonal strokes that sit behind the
// charcoal bands on the corporate site. Purely decorative; stretches to
// fill its positioned parent.
export default function FlowLines({ className = '' }) {
  return (
    <svg className={`absolute inset-0 w-full h-full pointer-events-none ${className}`}
      viewBox="0 0 100 100" preserveAspectRatio="none" aria-hidden="true">
      <line x1="0" y1="100" x2="34" y2="10" stroke="#aa5b3f" strokeWidth="1" vectorEffect="non-scaling-stroke" />
      <line x1="0" y1="72" x2="23" y2="100" stroke="#479AC2" strokeWidth="1" vectorEffect="non-scaling-stroke" />
      <line x1="68" y1="10" x2="82" y2="100" stroke="#c8bd3e" strokeWidth="1" vectorEffect="non-scaling-stroke" />
    </svg>
  );
}
